import { gql } from '@apollo/client'

export const NoteFragment = gql`
    fragment noteFragment on ProjectNote {
        description
        firmId
        id
        metadata {
            creatorId
            updated
        }
        name
        noteType
        projectId
        state
        noteBreadCrumbs
        contentItemId
        projectElementDescription
    }
`
